/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {AddMediaToVOGSetRequest} from "../model/add-media-to-vog-set-request";
import {CreateByNameRequest} from "../model/create-by-name-request";
import {DeleteBatchVOGSetRequest} from "../model/delete-batch-vog-set-request";
import {DeleteVOGSetRequest} from "../model/delete-vog-set-request";
import {DuplicateVOGSetRequest} from "../model/duplicate-vog-set-request";
import {ListData} from "../model/list-data";
import {SuccessCreateResponse} from "../model/success-create-response";
import {SuccessResponse} from "../model/success-response";
import {VOGSet} from "../model/vog-set";

@Injectable({
    providedIn: "root",
})
export class SimVOGSetService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public addMediatoVOGSet(vogSetRequest: AddMediaToVOGSetRequest) {
        return super.post<SuccessResponse>(`/api/VOGSet/AddMediatoVOGSet`, vogSetRequest);
    }

    public createVOGSet(vogSetRequest: CreateByNameRequest) {
        return super.post<SuccessCreateResponse>(`/api/VOGSet/CreateVOGSet`, vogSetRequest);
    }

    public deleteBatchVOGSet(request: DeleteBatchVOGSetRequest) {
        return super.post<SuccessResponse>(`/api/VOGSet/DeleteBatchVOGSet`, request);
    }

    public deleteVOGSet(vogSetRequest: DeleteVOGSetRequest) {
        return super.post<SuccessResponse>(`/api/VOGSet/DeleteVOGSet`, vogSetRequest);
    }

    public downloadVOGSet_Url(vogSetId: string) {
        return super.getUrl(`/api/VOGSet/DownloadVOGSet`, {vogSetId: vogSetId});
    }

    public duplicateVOGSet(vogSetRequest: DuplicateVOGSetRequest) {
        return super.post<SuccessResponse>(`/api/VOGSet/DuplicateVOGSet`, vogSetRequest);
    }

    public getDefaultVogSet() {
        return super.get<VOGSet>(`/api/VOGSet/GetDefaultVogSet`, );
    }

    public getFilteredVOGSets(searchTerm: string = null, searchColumn: string = "name", sortColumn: string = "name", sortAscending: boolean = true, page: number = 0, pageSize: number = 2147483647) {
        return super.get<ListData<VOGSet>>(`/api/VOGSet/GetFilteredVOGSets`, {searchTerm: searchTerm, searchColumn: searchColumn, sortColumn: sortColumn, sortAscending: sortAscending, page: page, pageSize: pageSize});
    }

    public getVogSetById(vogSetId: string) {
        return super.get<VOGSet>(`/api/VOGSet/GetVogSetById`, {vogSetId: vogSetId});
    }

    public getVogSetByName(vogSetName: string) {
        return super.get<VOGSet>(`/api/VOGSet/GetVogSetByName`, {vogSetName: vogSetName});
    }

    public listVOGSets(searchTerm: string = null, sortColumn: string = "name", sortAscending: boolean = true, page: number = 0, pageSize: number = 2147483647) {
        return super.get<ListData<VOGSet>>(`/api/VOGSet/ListVOGSets`, {searchTerm: searchTerm, sortColumn: sortColumn, sortAscending: sortAscending, page: page, pageSize: pageSize});
    }

    public saveVOGSet(vog: VOGSet) {
        return super.post<SuccessResponse>(`/api/VOGSet/SaveVOGSet`, vog);
    }
}